import { useTranslation } from 'react-i18next';

import './notification-permission-animation.css';

export function NotificationPermissionAnimation() {
  const { t } = useTranslation('authenticated.notifications');

  return (
    <div className="notification-anim-scene">
      <div className="notification-anim-browser-bar">
        <div className="notification-anim-dots">
          <span style={{ background: '#ea4335' }} />
          <span style={{ background: '#fbbc04' }} />
          <span style={{ background: '#34a853' }} />
        </div>
        <div className="notification-anim-url">
          <svg width="8" height="10" viewBox="0 0 8 10" fill="none">
            <rect x="1" y="4" width="6" height="5.5" rx="1" fill="currentColor" opacity="0.5" />
            <path
              d="M2.5 4V3a1.5 1.5 0 013 0v1"
              stroke="currentColor"
              strokeWidth="1"
              fill="none"
              opacity="0.5"
            />
          </svg>
          <span className="notification-anim-url-text">{t('permissionModal.animation.url')}</span>
        </div>
      </div>

      <div className="notification-anim-popup">
        <div className="notification-anim-popup-header">
          <div className="notification-anim-bell-wrap">
            <div className="notification-anim-bell-pulse" />
            <svg className="notification-anim-bell-svg" viewBox="0 0 32 32" fill="none">
              <path
                d="M16 4C13.2 4 10 6.4 10 10v6l-2 3v1h16v-1l-2-3v-6c0-3.6-3.2-6-6-6z"
                className="notification-anim-bell-fill"
                opacity="0.9"
              />
              <path
                d="M10 20h12"
                className="notification-anim-bell-ring-stroke"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <circle cx="16" cy="26" r="2" className="notification-anim-bell-fill" />
              <circle cx="16" cy="4.5" r="1.5" className="notification-anim-bell-ring-fill" />
            </svg>
          </div>
          <div className="notification-anim-text-block">
            <div className="notification-anim-title">{t('permissionModal.animation.title')}</div>
            <div className="notification-anim-sub">{t('permissionModal.animation.subtitle')}</div>
          </div>
        </div>

        <div className="notification-anim-actions">
          <button className="notification-anim-btn-block" tabIndex={-1}>
            {t('permissionModal.animation.block')}
          </button>
          <div className="notification-anim-allow-wrap">
            <button className="notification-anim-btn-allow" tabIndex={-1}>
              {t('permissionModal.animation.allow')}
            </button>
            <div className="notification-anim-cursor-wrap">
              <svg className="notification-anim-cursor-svg" viewBox="0 0 22 22" fill="none">
                <path
                  d="M4 2l14 9-7 1-4 7z"
                  className="notification-anim-cursor-fill"
                  opacity="0.85"
                />
                <path
                  d="M4 2l14 9-7 1-4 7z"
                  className="notification-anim-cursor-stroke"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
